export default __webpack_public_path__ + "static/media/iconBat.924549d1.png";